import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { TOOLS_LIST, EXCEL_TOOLS_LIST, CATEGORIES, SITE_NAME } from "../translations";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-900 text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <img src="/favicon.png" alt="FileNesto icon" width="28" height="28" loading="lazy" className="w-7 h-7" />
              <span className="font-bold text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {SITE_NAME}
              </span>
            </div>
            <p className="text-sm text-slate-300">{t.footer.tagline}</p>
          </div>

          {/* PDF + Excel Tools */}
          <div>
            <h4 className="font-semibold text-white mb-3 text-sm uppercase tracking-wider">
              {t.footer.tools}
            </h4>
            <ul className="space-y-2">
              {TOOLS_LIST.slice(0, 5).map((tool) => (
                <li key={tool.slug}>
                  <Link to={`/${tool.slug}`} className="text-sm text-slate-300 hover:text-white transition-colors">
                    {t.tools[tool.key]?.title}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-300 mt-4 mb-2">Excel</p>
            <ul className="space-y-2">
              {EXCEL_TOOLS_LIST.map((tool) => (
                <li key={tool.slug}>
                  <Link to={`/${tool.slug}`} className="text-sm text-slate-300 hover:text-white transition-colors">
                    {t.tools[tool.key]?.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-semibold text-white mb-3 text-sm uppercase tracking-wider">
              {t.footer.categories}
            </h4>
            <ul className="space-y-2">
              {CATEGORIES.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/${cat.slug}`} className="text-sm text-slate-300 hover:text-white transition-colors flex items-center gap-2">
                    {t.nav[cat.labelKey]}
                    {!cat.live && <span className="text-[10px] text-slate-300 bg-slate-700 px-1.5 py-0.5 rounded">{t.categories.soonBadge}</span>}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-3 text-sm uppercase tracking-wider">
              {t.footer.legal}
            </h4>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-sm text-slate-300 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/about" className="text-sm text-slate-300 hover:text-white transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-300 hover:text-white transition-colors">{t.nav.contact}</Link></li>
              <li><Link to="/privacy-policy" className="text-sm text-slate-300 hover:text-white transition-colors">{t.nav.privacy}</Link></li>
              <li><Link to="/terms-of-service" className="text-sm text-slate-300 hover:text-white transition-colors">{t.nav.terms}</Link></li>
              <li><Link to="/disclaimer" className="text-sm text-slate-300 hover:text-white transition-colors">{t.nav.disclaimer}</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-10 pt-6 text-xs text-slate-300 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <p>{t.footer.privacyNote}</p>
          <p>© {new Date().getFullYear()} {SITE_NAME}</p>
        </div>
      </div>
    </footer>
  );
}
